import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import CreateTicketingGroup from './pages/CreateTicketingGroup';
import TicketManagement from './pages/TicketManagement';
import BillingUpload from './pages/BillingUpload';
import TicketsList from './pages/TicketsList';
import Reconciliation from './pages/Reconciliation';
import Layout from './components/layout/Layout';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Dashboard data-id="element-5" />} data-id="element-4" />
          <Route path="create-group" element={<CreateTicketingGroup data-id="element-7" />} data-id="element-6" />
          <Route path="edit-group/:groupId" element={<CreateTicketingGroup data-id="element-9" />} data-id="element-8" />
          <Route path="tickets" element={<TicketsList data-id="element-11" />} data-id="element-10" />
          <Route path="tickets/:gsId" element={<TicketManagement data-id="element-13" />} data-id="element-12" />
          <Route path="billing-upload" element={<BillingUpload data-id="element-15" />} data-id="element-14" />
          <Route path="reconciliation" element={<Reconciliation data-id="element-17" />} data-id="element-16" />
        </Route>
      </Routes>
    </BrowserRouter>;
}